<img class="fullsked-logo" src="assets/img/fullsked-logo.svg" alt="Fullsked Logo" />

<form [formGroup]="form">
  @if (loadingValid()) {
    <oph-loading></oph-loading>
  } @else {
    @if (view() === 'valid') {
      <h3>Create a new password.</h3>
      <div class="password-input-container mb-20">
        <input
          formControlName="password"
          placeholder="New password"
          [type]="passwordInputType()"
          class="password-input"
        />
        <button class="show-password-button" type="button" (click)="onTogglePassword($event)">
          <oph-icon
            [name]="passwordInputType() === 'text' ? 'show-password' : 'hide-password'"
            class="show-password-icon"
            matSuffix
          ></oph-icon>
        </button>
      </div>
      <div class="password-input-container mb-20">
        <input
          formControlName="confirmPassword"
          placeholder="Confirm password"
          [type]="passwordConfirmInputType()"
          class="password-input"
        />
        <button class="show-password-button" type="button" (click)="onToggleConfirmPassword($event)">
          <oph-icon
            [name]="passwordConfirmInputType() === 'text' ? 'show-password' : 'hide-password'"
            class="show-password-icon"
            matSuffix
          ></oph-icon>
        </button>
      </div>
      <div class="button-container">
        <button class="go-button" type="button" (click)="onGo()">
          @if (loadingReset()) {
            <div class="oph-white-spinner">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
          } @else {
            Go
          }
        </button>
      </div>
      <div class="error-msg">
        <small data-test="login-form-error">{{ errorMessage() }}</small>
      </div>
    }
    @if (view() === 'invalid') {
      <h3>Link Not Valid</h3>
      @if (errorMessage()) {
        <p>{{ errorMessage() }}</p>
      }

      <button class="button back" type="button" (click)="onLogin($event)">Back to Login</button>
    }
    @if (view() === 'passwordChanged') {
      <h3>Your password has been successfully changed!</h3>
      <div class="button-container center">
        <button class="button back" type="button" (click)="onLogin($event)">Login</button>
      </div>
    }
  }
</form>
